/**
 * Énumérations propres au wallet-service (complément de l'annexe A exposée
 * par `@/features/shared/api/enums`).
 *
 * Les valeurs circulent en chaînes MAJUSCULES et sont transmises
 * littéralement : une valeur inconnue provoque une erreur de conversion
 * côté serveur, pas un défaut silencieux (§4.4).
 */

/**
 * Statut d'une contestation de transfert (`DisputeStatus`, annexe A v3.1 :
 * OPEN, REVERSED, REJECTED). La collection Postman v3.1 utilise `ACTIVE`
 * dans ses exemples — écart connu, la prose du guide et l'annexe font foi.
 */
export const TRANSACTION_DISPUTE_STATUSES = [
  "OPEN",
  "REVERSED",
  "REJECTED",
] as const;
export type TransactionDisputeStatus =
  (typeof TRANSACTION_DISPUTE_STATUSES)[number];

/**
 * Fenêtre d'ouverture d'une contestation par l'expéditeur, en minutes
 * (`Disputes__OpeningWindowMinutes`, guide v3.1 — 1 h après l'envoi).
 */
export const TRANSACTION_DISPUTE_OPENING_WINDOW_MINUTES = 60;
